import MatchedMap from 'utilities/src/matchedMap';

import { InputVariantsEnum } from '../../../utils/variants';
import { InputTypeEnum } from '../../../utils/types';
import { type InputThemeProps } from '../../../utils/themes';

/**
 * LabelIn Common Classes
 */

const labelInClasses = '';

const labelInOptionalClasses = '';

/**
 * LabelIn Focus Classes
 */

const labelInFocusTypeClasses = new MatchedMap([
  [InputTypeEnum.Input, ''],
  [InputTypeEnum.Textarea, ''],
]);

const labelInFocusVariantClasses = new MatchedMap([
  [InputVariantsEnum.Primary, ''],
  [InputVariantsEnum.Secondary, ''],
]);

/**
 * Site Theme
 */

const inputLabelInSiteTheme = ({
  inputType,
  inputVariant,
}: Pick<InputThemeProps, 'inputType' | 'inputVariant'>) => ({
  labelInThemeClasses: labelInClasses,
  labelInOptionalThemeClasses: labelInOptionalClasses,
  labelInFocusThemeClasses: labelInFocusTypeClasses
    .get(InputTypeEnum[inputType])
    .concat(' ', labelInFocusVariantClasses.get(InputVariantsEnum[inputVariant])),
});

export default inputLabelInSiteTheme;
